import api from "./core";

const basePath = "api/portal/Forms";

export default {
  async get(id) {
    const result = await api.get(`${basePath}/${id}`);
    return result.data;
  },
  async getVersions(id) {
    const result = await api.get(`${basePath}/${id}/Versions`);
    return result.data;
  }
};
